export const PROVIDER_TTL_ES = 'Proveedores';
export interface IProviderBase {
  ruc: string;
  name: string;
  address: string;
  email: string;
  mobile: string;
}
export interface IProvider extends IProviderBase {
  id: number;
}

export type IUpdateProviders = Partial<IProviderBase>;
